<template>
  <v-card class="">
    <v-date-picker
      v-model="date"
      header-color="#718FC7"
      :width="width"
      :title-date-format="getTitleDate"
      :weekday-format="getDay"
      :month-format="getMonth"
      :header-date-format="getHeaderDate"
      :no-title="noTitle"
    >
      <template class>
        <div
          class="d-flex justify-space-between align-center"
          :style="{ width: width + 'px' }"
        >
          <div class="d-flex">
            <v-btn
              color="#3F557D"
              class="color-white mr-2"
              rounded
              width="120"
              height="42"
              @click="onUpdateDate(date)"
              >선택완료
            </v-btn>

            <v-btn
              @click="$emit('close:date')"
              color="#DADADA"
              class="color-white "
              rounded
              width="120"
              height="42"
              >닫기
            </v-btn>
          </div>

          <v-btn
            color="#3F557D"
            class="color-white"
            rounded
            width="76"
            height="30"
            @click="onResetDate"
          >
            초기화
          </v-btn>
        </div>
      </template>
    </v-date-picker>
  </v-card>
</template>

<script>
/** emits 선언 close:date 닫기버튼 / update:date 날짜업데이트 */
export default {
  props: {
    resetDate: { Type: String, require: false, default: null },
    width: { Type: String, require: false, default: "388" },
    noTitle: { Type: Boolean, require: false, default: false },
  },
  data: () => ({
    date: "",
  }),
  methods: {
    onResetDate() {
      this.date = this.resetDate ? this.resetDate : this.getToday();
      this.$emit("update:date", this.date);
    },
    onUpdateDate(val) {
      this.date = val;
      this.$emit("update:date", this.date);
    },
    getToday() {
      const today = new Date();
      const YY = today.getFullYear();
      const MM = String(today.getMonth() + 1).padStart(2, "0");
      const DD = String(today.getDate()).padStart(2, "0");

      return `${YY}-${MM}-${DD}`;
    },
    getDay(date) {
      const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
      let week = new Date(date).getDay(date);
      return daysOfWeek[week];
    },
    getMonth(date) {
      const monthName = [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
      ];
      let month = new Date(date).getMonth(date);
      return monthName[month];
    },
    getHeaderDate(date) {
      const [year, month] = date.split("-");
      return month ? `${year}년 ${month}월` : `${year}년`;
    },
    getTitleDate(date) {
      const parsedDate = new Date(date);
      const month = parsedDate.getMonth() + 1; // 월은 0부터 시작하므로 +1 필요
      const day = parsedDate.getDate(); // 일
      return `${month}월 ${day}일`;
    },
  },
};
</script>
